module.exports = __webpack_public_path__ + "6921c3fad4c739632b6689f7ed4bf725.jpg";